import { EMPTY_OBJECT } from 'utils/emptyConstants'

export const selectPSAWizard = (state) => state.psaWizard || EMPTY_OBJECT

export const selectPSAWizardSchema = (state, providerKey) =>
  selectPSAWizard(state).schemaByProvider?.[providerKey] || null
export const selectPSAWizardConfig = (state) => selectPSAWizard(state).config || null
export const selectPSAWizardError = (state) => selectPSAWizard(state).error || null

export const selectPSAWizardAction = (state, requestId) =>
  (requestId && selectPSAWizard(state).actions?.[requestId]) || null
export const selectPSAWizardActionPending = (state, actionTypes) =>
  Object.values(selectPSAWizard(state).actions || EMPTY_OBJECT).some(
    (request) => request.status === 'pending' && actionTypes.includes(request.actionType)
  )

export const selectPSAWizardSaveLoading = (state) => !!selectPSAWizard(state).saveLoading
export const selectPSAWizardSaveError = (state) => selectPSAWizard(state).saveError || null
export const selectPSAWizardSaveResult = (state) => selectPSAWizard(state).saveResult || null

export const selectPsaTiles = (state) => selectPSAWizard(state).tiles || EMPTY_OBJECT
export const selectPsaDisabling = (state) => selectPSAWizard(state).disabling || EMPTY_OBJECT
